import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

import Modal from 'app/components/Modal';
import modalStyles from 'shared/components/modalStyles';
import config from 'shared/config/config';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';

import {
  setPhotoSwipeHidden
} from 'app/actions/photoSwipeActions';

import {
  showTimeOutDialog
} from 'app/actions/kioskActions';

const isViewPhotosItem = localStorage.getItem('VIEW_PHOTOS');
const isViewPhotos = isViewPhotosItem === 'false' || !isViewPhotosItem ? false : true;


const styles = () => ({
  button: {
    float: 'left',
    width: '100%',
    marginBottom: '0.5rem',
    textAlign: 'center',
    padding: '0.3rem 1rem',
    fontSize: '1.5rem',
    fontWeight: 600,
    background: config.kiosk_modal_button_action_bg_color,
    border: config.kiosk_modal_button_action_border,
    borderRadius: '3px',
    boxShadow: '0 0 2px #dcdcdc',
    color: config.kiosk_modal_button_action_font_color
  },
  message: {
    fontFamily: config.sub_font,
    color: config.kiosk_modal_content_font_color,
    margin: '1.5rem 0'
  },
  ...modalStyles()
});

class TimeOutDialog extends React.Component {

  constructor(props) {
    super(props);

    // todo: allow disabling with URL param or similar
    this.disabled = isViewPhotos;

    // internal tracking of elapsed seconds.
    // outside of state to avoid excess state changes
    this.elapseSec = props.settings.timeout;

    this.state = {
      isOpen: false,

      // displayed when modal is open
      visibleCountdown: this.elapseSec
    }
  }

  componentDidMount() {
    if (this.disabled) {
      return;
    }

    if (this.props.settings.timeout && this.props.timeOutDialogVisible) {
      this.startInterval();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.timeOutDialogVisible !== this.props.timeOutDialogVisible) {
      if (this.props.timeOutDialogVisible) {
        this.clearInterval();
        this.elapseSec = this.props.settings.timeout;
        this.setState({ visibleCountdown: this.elapseSec });
        this.startInterval();
      }
    }
  }

  componentWillUnmount() {
    if (this.disabled) {
      return;
    }

    if (this.props.settings.timeout) {
      window.clearInterval(this.interval);
    }
  }

  close() {
    this.clearInterval();
    this.props.setPhotoSwipeHidden(false);
    this.props.showTimeOutDialog(false);
    this.elapseSec = this.props.settings.timeout;
    this.setState({ visibleCountdown: this.elapseSec });
    window.currentModal && window.currentModal.close();
  }

  logout() {
    this.close();
    this.props.logout();
  }

  startInterval() {
    this.interval = window.setInterval(() => {
      if (this.elapseSec === 0) {
        if (this.props.timeOutDialogVisible) {
          this.logout();
        }
      } else {
        if (this.props.timeOutDialogVisible) {
          this.setState({ visibleCountdown: this.elapseSec });
          this.elapseSec -= 1;
        }
      }
    }, 1000);
  }

  clearInterval() {
    window.clearInterval(this.interval);
  }

  renderTimeOutSlide() {
    const { classes } = this.props;

    let slide = {};

    slide.component = (
      <div>
        <div className={classes.modalSlide}>
          <div className={classes.modalHeader}>
            <span style={{ fontWeight: 600 }}>
              <FormattedMessage {...messages.kiosk_auto_logout_title} />
            </span>
          </div>
          <p className={classes.message}>
            <FormattedMessage {...withValues(messages.kiosk_auto_logout_subtitle, { count: this.state.visibleCountdown })} />
            <br />
          </p>
          <hr />
          <button className={classes.button} onClick={this.close.bind(this)}>
            <FormattedMessage {...messages.button_stay} />
          </button>
        </div>
      </div>
    );

    slide.buttons = [];

    return slide;
  }

  render() {
    const { classes } = this.props;

    let slides = [];
    let slide = this.renderTimeOutSlide();
    slides.push(slide);
    return (
      <>
        <Modal
          open={this.props.timeOutDialogVisible}
          close={this.close.bind(this)} slides={slides}>
        </Modal>
      </>
    )
  }
}

const mapStateToProps = state => ({
  settings: state.kioskReducer.settings,
  timeOutDialogVisible: state.kioskReducer.timeOutDialogVisible
});

export default connect(mapStateToProps, { setPhotoSwipeHidden, showTimeOutDialog })(withStyles(styles)(TimeOutDialog));
